import { ServiceOrders } from 'core/layout-core/core-content/Dashboards/ServiceOrders/ServiceOrders';
import { FilesInProcessContent } from 'core/layout-core/core-content/FileContent/FilesInProcessContent';
import OnBehalfOFSearch from 'core/layout-core/core-content/OnBehalfOFSearch';
import { AllOrdersContent } from 'core/layout-core/core-content/OrderManagement/AllOrdersContent';
import { InvoicesContent } from 'core/layout-core/core-content/OrderManagement/InvoicesContent';
import OrderManagementUnauthorizedAccessContent from 'core/layout-core/core-content/OrderManagement/OrderManagementUnauthorizedAccessContent';
import { RedirectToAllOrdersContent } from 'core/layout-core/core-content/OrderManagement/RedirectToAllOrdersContent';
import AutopayServices from 'core/layout-core/core-content/Payment/AutopayServices';
import { RemittanceReceivablesContent } from 'core/layout-core/core-content/Remittance/RemittanceReceivablesContent';
import AddressBook from 'features/admin/AddressBook';
import AdminUserProfileContainer from 'features/admin/AdminUserProfileContainer';
import AdminUserProfileContent from 'features/admin/AdminUserProfileContent';
import autoReporting from 'features/admin/autoReporting/autoReporting';
import Signature from 'features/admin/e-signatures/Signature';
import IdaasContent from 'features/admin/IdaasContent';
import IdaasSignedUp from 'features/admin/IdaasSignedUp';
import IdaasSignUp from 'features/admin/IdaasSignUp';
import IntegrationsFeatures from 'features/admin/integrations-features/IntegrationsFeatures';
import ManageUsers from 'features/admin/manageUsers/manageUsers';
import PrefferedOfficeContent from 'features/admin/preferredOfficeContent';
import UserStatus from 'features/admin/UserStatus';
import documents from 'features/documents/documentsContainer';
import { FileSummaryMap } from 'features/files/files-summary/file-summary-google-map/FileSummaryMap';
import CertifyReportContainer from 'features/files/fincen-reporting/certify-report/CertifyReportContainer';
import FilingInformationContainer from 'features/files/fincen-reporting/filing-information/FilingInformationContainer';
import PaymentInformationContainer from 'features/files/fincen-reporting/payment-information/PaymentInformationContainer';
import PropertyInformationContainer from 'features/files/fincen-reporting/property-information/PropertyInformationContainer';
import ReportPartyInformationContainer from 'features/files/fincen-reporting/report-party-information/ReportPartyInformationContainer';
import ReportingLayout from 'features/files/fincen-reporting/ReportingLayout';
import SummaryContainer from 'features/files/fincen-reporting/summary/SummaryContainer';
import TransfereeInformationContainer from 'features/files/fincen-reporting/transferee-information/TransfereeInformationContainer';
import TransferorInformationContainer from 'features/files/fincen-reporting/transferor-information/TransferorInformationContainer';
import OrderInsightsContent from 'features/files/order-insights/OrderInsightsContent';
import FirmRedirect from 'features/firms/FirmRedirect';
import { ArticlePage } from 'features/help/ArticlePage';
import HelpHomePage from 'features/help/HelpHomePage';
import { SearchResultPage } from 'features/help/SearchResultPage';
import { TopicPage } from 'features/help/TopicPage';
import { ClosedOrderDetails } from 'features/orderManagement/ClosedOrderDetails';
import { FileSummaryReport } from 'features/pdf/fileSummary/FileSummaryReport';
import { HelpArticle } from 'features/pdf/helpArticle/HelpArticle';
import IntellicheckReport from 'features/pdf/intelliCheck/IntellicheckReport';
import AvlList from 'features/services/agencyVerificationLetters/AvlList';
import AnmRedirect from 'features/services/anmRedirect/AnmRedirect';
import PartyVerification from 'features/services/identityVerification/PartyVerification';
import WireVerification from 'features/services/wireVerification/WireVerification';
import PolicyUpload from 'features/services/policyupload/PolicyUpload';
import statements from 'features/statements/Statements';
import ContactUs from 'utilities/contact-us/contact-us';
import TitleMonitoringSignup from 'utilities/title-monitoring-signup/title-monitoring-signup';
import IdentityVerification from 'utilities/verification/IdentityVerification';
import CPLSummary from '../../features/cpl/CPLContainer';
import FilesList from '../../features/files/files-summary/files-list/FilesList';
import JacketsContainer from '../../features/jackets/JacketsContainer';
import ServiceOrdersContainer from '../../features/serviceorder/ServiceOrdersContainer';
import BackTitleContent from '../../features/services/backtitleAdhoc/BackTitleContent';
import SdnContent from '../../features/services/sdnAdhoc/SdnContent';
import Underwriting from '../../features/underwriting/Underwriting';
import AccountRegistration from '../../utilities/account-registration/account-registration';
import ForgotPassword from '../../utilities/Authentication/ForgotPassword';
import ForgotUserID from '../../utilities/Authentication/ForgotUserID';
import Verification from '../../utilities/verification/verification';
import Dashboard from '../layout-core/core-content/Dashboard';
import { Files } from '../layout-core/core-content/FileContent/FileContent';
import FileInfoContainer from '../layout-core/core-content/FileContent/FileInfoContainer';
import OrderManagement from '../layout-core/core-content/OrderManagement/OrderManagementContent';
import Reports from '../layout-core/core-content/Remittance/ReportContent';
import MyReports from '../layout-core/core-content/Reports/MyReportsContent';
import ServiceContent from '../layout-core/core-content/ServiceContent';
import Invoices from '../layout-core/core-content/ServiceOrderInvoices/InvoiceContent';
import PolicyNumberManagement from 'features/admin/policyNumberManagement/PolicyNumberManagement';
import FormManagement from 'features/admin/formManagement/FormManagement';
import AccountNotFound from 'features/admin/AccountNotFound';
import OracleDowntimeList from 'features/OracleDowntimeSchedule/OracleDowntimeList';
import BillingMethods from 'core/layout-core/core-content/Payment/BillingMethods';
import PaymentMethodDetail from 'core/layout-core/core-content/Payment/PaymentMethodDetail';

export enum Layout {
  AuthLayout = 'AuthLayout',
  PublicLayout = 'PublicLayout',
  UserNotFoundLayout = 'UserNotFoundLayout',
  HelpLayout = 'HelpLayout',
  RedirectLayout = 'RedirectLayout',
  PDFLayout = 'PDFLayout',
}

export type RouteType = {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any;
  isPublic?: boolean;
  layout?: Layout;
  routes?: Array<RouteType>;
  isAdminView?: boolean;
  location?: any;
  requiredPermission?: string | string[];
  isNested?: boolean;
  exact?: boolean;
};

export const routes: Array<RouteType> = [
  {
    path: '/verification',
    component: Verification,
    isPublic: true,
  },
  {
    path: '/contact-us',
    component: ContactUs,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/title-monitoring-signup/:firmGuid?',
    component: TitleMonitoringSignup,
    isPublic: true,
  },
  {
    path: '/account-registration',
    component: AccountRegistration,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/Authentication/ForgotPassword',
    component: ForgotPassword,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/start-identity-verification/:tokenId',
    component: IdentityVerification,
    isPublic: true,
  },
  {
    path: '/Authentication/ForgotUserID',
    component: ForgotUserID,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/searchFirms',
    component: OnBehalfOFSearch,
    layout: Layout.AuthLayout,
  },
  {
    component: Reports,
    layout: Layout.AuthLayout,
    path: '/accounting/remittance/:action/:firmId?',
    requiredPermission: ['hasFirmId', 'pay', 'remit'],
  },
  {
    path: '/accounting/service-order-invoices/pay',
    component: Invoices,
    layout: Layout.AuthLayout,
    requiredPermission: ['pay', 'remit'],
  },
  {
    path: '/accounting/service-order-invoices/view-invoices/:firmId?',
    component: Invoices,
    layout: Layout.AuthLayout,
    requiredPermission: ['serviceOrderInvoices'],
  },
  {
    path: '/admin/oracle-downtime-schedule',
    component: OracleDowntimeList,
    layout: Layout.AuthLayout,
    requiredPermission: ['orderManagementAdmin'],
  },
  {
    path: '/admin/oracle-downtime-schedule',
    component: OracleDowntimeList,
    layout: Layout.AuthLayout,
    requiredPermission: ['orderManagementAdmin'],
  },
  {
    path: '/admin/invoices',
    component: InvoicesContent,
    layout: Layout.AuthLayout,
    requiredPermission: ['invoiceDashboard'],
  },
  {
    path: '/anm-redirect',
    component: AnmRedirect,
    layout: Layout.RedirectLayout,
  },
  {
    path: '/services',
    component: ServiceContent,
    routes: [
      {
        path: '/services/sdn-search',
        component: SdnContent,
      },
      {
        path: '/services/back-title-search',
        component: BackTitleContent,
        requiredPermission: ['canRunBackTitleAdHoc'],
      },
      {
        path: '/services/agency-verification-letters',
        component: AvlList,
        requiredPermission: ['agencyVerificationLetters'],
      },
      {
        path: '/services/policy-upload',
        component: PolicyUpload,
        requiredPermission: ['canRunPolicyUpload'],
      },
      {
        path: '/services/policy-upload/upload',
        component: PolicyUpload,
        requiredPermission: ['canRunPolicyUpload'],
      },
      {
        path: '/services/policy-upload/history',
        component: PolicyUpload,
        requiredPermission: ['canRunPolicyUpload'],
      },
      {
        path: '/services/fraud-prevention/identity-verification',
        component: PartyVerification,
      },
      {
        path: '/services/fraud-prevention/wire-verification',
        component: WireVerification,
      },
    ],
    layout: Layout.AuthLayout,
  },
  {
    path: '/dashboards',
    component: ServiceOrders,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'dashboard'],
    routes: [
      {
        path: '/dashboards/service-orders',
        component: ServiceOrders,
      },
    ],
  },
  {
    path: '/files',
    component: Files,
    layout: Layout.AuthLayout,
    routes: [
      {
        path: '/files/:fileId/order-insights',
        component: OrderInsightsContent,
        requiredPermission: ['hasFirmId'],
      },
      {
        path: '/files/:fileId/file-info',
        component: FileInfoContainer,
        requiredPermission: ['hasFirmId'],
      },
      {
        path: '/files/map/:fileId',
        component: FileSummaryMap,
        requiredPermission: ['hasFirmId'],
      },
      {
        path: '/files/:fileId/service-orders',
        component: ServiceOrdersContainer,
        requiredPermission: ['hasFirmId', 'serviceOrders'],
      },
      {
        path: '/files/:fileId/cpl',
        component: CPLSummary,
        requiredPermission: ['hasFirmId', 'cpl'],
      },
      {
        path: '/files/:fileId/jackets',
        component: JacketsContainer,
        requiredPermission: ['hasFirmId', 'jackets'],
      },
      {
        path: '/files/:fileId/underwriting',
        component: Underwriting,
        requiredPermission: ['hasFirmId', 'underwriting'],
      },
      {
        path: '/files/:fileId/back-title',
        component: BackTitleContent,
        requiredPermission: ['hasFirmId', 'backtitle'],
      },
      {
        path: '/files/:fileId/documents',
        component: documents,
        requiredPermission: ['hasFirmId'],
      },
      {
        path: '/files/:fileId/fincen-reporting',
        component: ReportingLayout,
        requiredPermission: ['hasFirmId'],
        exact: false,
        routes: [
          {
            path: '/files/:fileId/fincen-reporting/filing-information',
            component: FilingInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/property-information',
            component: PropertyInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/property-info',
            component: PropertyInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/report-party',
            component: ReportPartyInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/transferee-info',
            component: TransfereeInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/transferor-info',
            component: TransferorInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/payment-info',
            component: PaymentInformationContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/certify-generate',
            component: CertifyReportContainer,
          },
          {
            path: '/files/:fileId/fincen-reporting/summary',
            component: SummaryContainer,
          },
        ],
      },
      {
        path: '/files',
        exact: true,
        component: FilesList,
        requiredPermission: ['hasFirmId'],
      },
    ],
    requiredPermission: ['hasFirmId'],
  },
  {
    path: '/admin/address-book',
    component: AddressBook,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'addressBook'],
  },
  {
    path: '/statements/:firmId?',
    component: statements,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId'],
  },
  {
    path: '/admin/billing/:paymentMethodId',
    component: PaymentMethodDetail,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'billing'],
  },
  {
    path: '/admin/billing',
    component: BillingMethods,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'billing'],
  },
  {
    path: '/admin/autopay-services',
    component: AutopayServices,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'billing'],
  },
  {
    path: '/admin/user/',
    component: AdminUserProfileContainer,
    layout: Layout.AuthLayout,
    routes: [
      {
        path: '/admin/user/profile/update',
        component: IdaasContent,
        isAdminView: false,
        requiredPermission: [],
      },
      {
        path: '/admin/user/profile',
        component: AdminUserProfileContent,
        isAdminView: false,
        requiredPermission: [],
      },
      {
        path: '/admin/user/preferred-offices',
        component: PrefferedOfficeContent,
        isAdminView: false,
        requiredPermission: [],
      },
    ],
  },
  {
    path: '/admin/integrations-features',
    component: IntegrationsFeatures,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId'],
  },
  {
    path: '/authentication/register/:p?',
    component: IdaasSignUp,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/eula',
    component: IdaasSignedUp,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/507',
    component: UserStatus,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/401',
    component: UserStatus,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/404',
    component: AccountNotFound,
    layout: Layout.UserNotFoundLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/403/disabled',
    component: UserStatus,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/403/inactive',
    component: UserStatus,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/authorization/userstatus/500',
    component: UserStatus,
    layout: Layout.PublicLayout,
    isPublic: true,
  },
  {
    path: '/admin/auto-reporting',
    component: autoReporting,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'autoReporting'],
  },
  {
    path: '/admin/e-signatures',
    component: Signature,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'eSignatures'],
  },
  {
    path: '/admin/policy-number-management',
    component: PolicyNumberManagement,
    layout: Layout.AuthLayout,
    exact: true,
    requiredPermission: ['hasFirmId', 'behalfOfUser', 'inventoryManagement'],
  },
  {
    path: '/admin/form-management',
    component: FormManagement,
    layout: Layout.AuthLayout,
    exact: true,
    requiredPermission: ['inventoryManagement'],
  },
  {
    path: '/admin/users/manage',
    component: ManageUsers,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'manageUsers'],
  },
  {
    path: '/statements',
    component: statements,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'statements'],
  },
  {
    path: '/reporting',
    component: MyReports,
    layout: Layout.AuthLayout,
    requiredPermission: ['hasFirmId', 'reports'],
  },
  {
    path: '/help',
    component: HelpHomePage,
    layout: Layout.HelpLayout,
    routes: [
      {
        path: '/help/search',
        component: SearchResultPage,
      },
      {
        path: '/help/:topic/:article',
        component: ArticlePage,
      },
      {
        path: '/help/:topic',
        component: TopicPage,
      },
    ],
  },
  {
    path: '/pdf/fileSummaryReport/:fileId',
    component: FileSummaryReport,
    layout: Layout.PDFLayout,
    isPublic: true,
  },
  {
    path: '/pdf/helpArticle/:article',
    component: HelpArticle,
    layout: Layout.PDFLayout,
    isPublic: true,
  },
  {
    path: '/pdf/intelliCheckReport/:fileId/:transactionId',
    component: IntellicheckReport,
    layout: Layout.PDFLayout,
    isPublic: true,
  },
  {
    path: '/firms/:firmId',
    component: FirmRedirect,
  },
  // Order Management Section
  {
    path: '/order-management/all-orders',
    component: AllOrdersContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/files-in-process',
    component: FilesInProcessContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/invoices',
    component: InvoicesContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/remittance-receivables',
    component: RemittanceReceivablesContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/all-files',
    component: OrderManagement,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/order-queue',
    component: OrderManagement,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/closed-order-details',
    component: ClosedOrderDetails,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management/*',
    component: RedirectToAllOrdersContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-management',
    component: RedirectToAllOrdersContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/order-unauthorized-access',
    component: OrderManagementUnauthorizedAccessContent,
    layout: Layout.AuthLayout,
  },
  {
    path: '/:err?',
    component: Dashboard,
    layout: Layout.AuthLayout,
  },
];
